import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosDaviTurismo = {
    ...dadosAgenciaComum,
    id: 'daviturismo',
    nome: 'Davi Turismo',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-KQW83QS']
};
